import { useMutation, UseMutationResult } from '@tanstack/react-query'

import { brand } from '@/utils/brand'

export interface AppleTokenExchangePayload {
  code: string
  email?: string
  frontend_app: boolean
  urlPath: string
}

export type AppleTokenExchangeResponse = {
  auth_token?: string
  registered?: boolean
  existing?: boolean
  user_id?: string
  code?: string

  // these are set if the Apple user is new
  email?: string
  firstName?: string
  lastName?: string
  roles?: string[]
}

const exchangeAppleToken =
  (authBackend: string) =>
  async (payload: AppleTokenExchangePayload): Promise<AppleTokenExchangeResponse> => {
    const { urlPath, ...rest } = payload
    const response = await fetch(`${authBackend}${urlPath}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(rest),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Failed to post appleAuth')
    }

    return response.json()
  }

const useExchangeAppleToken = (): UseMutationResult<
  AppleTokenExchangeResponse,
  Error,
  AppleTokenExchangePayload,
  unknown
> => {
  const authBackend = process.env.NEXT_PUBLIC_AUTH_BACKEND || `https://www.staging.${brand.key}.com`

  return useMutation<AppleTokenExchangeResponse, Error, AppleTokenExchangePayload>({
    mutationFn: exchangeAppleToken(authBackend),
  })
}

export default useExchangeAppleToken
